var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_404 error error-6 d-flex bgi-size-cover bgi-position-center",style:({
      //backgroundImage: `url(${backgroundImage})`,
      //backgroundPosition: `center`,
      //backgroundSize: `cover`//
    })},[_c('div',{staticClass:"container d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"text_box"},[_c('h1',[_vm._v("Oops...")]),_c('h6',[_vm._v("Page Not Found")]),_c('p',[_vm._v("Looks like something went wrong. We're working on it")]),_c('router-link',{staticClass:"btn submit-btn-fill-color",attrs:{"to":"/"}},[_vm._v("Back to Homepage")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }